import React from "react";
import { Link } from "react-router-dom";

const Btn = ({ text, colour, link }) => {
  const linkStr = link[0] === "/" ? link : "/" + link;

  return (
    <Link to={linkStr}>
      <button className="app-btn" style={{ backgroundColor: colour }}>
        {text}
      </button>
    </Link>
  );
};

export default Btn;
